import { call, takeEvery, takeLatest, delay, all, put, select } from 'redux-saga/effects'
import { getIsLedgermapFetched } from './selectors'
import { savedLedgermap, fetchedLedgermap, storeSearchLedgermapResult, deletedLedgermap } from './actions'
import axios from 'axios';
import { handlError, parseError } from '../../app/serverError'
import { URL, getHeaderJWT } from '../../../store/path'
import userACL from '../../../store/access'
import { merge } from 'lodash'

// const delay = (ms) => new Promise(res => setTimeout(res, ms))

//#region Saga for Create Ledgermap 

function* createLedgermap() {
  yield takeEvery('CREATE_LEDGERMAP', saveLedgermap)
}

function* saveLedgermap(action) {
  const { response, error } = yield call(saveLedgermapAPI, action.payload)
  if (response) {
    const data = response.data || {}
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Save failed.'
      yield put(savedLedgermap(action.payload, 'error', msg))
    } else {
      yield put(savedLedgermap(action.payload, 'success', data.msg || data.data || 'Saved successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function saveLedgermapAPI(data) {
  try {
    const response = await axios.post(URL + '/master/ledgermap/add', data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Edited Ledgermap 

function* editLedgermap() {
  yield takeEvery('EDIT_LEDGERMAP', saveEditedLedgermap)
}

function* saveEditedLedgermap(action) {
  const { response, error } = yield call(editLedgermapAPI, action.payload)
  if (response) {
    const data = response.data || {}
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Update failed.'
      yield put(savedLedgermap(action.payload, 'error', msg))
    } else {
      yield put(savedLedgermap(action.payload, 'success', data.msg || data.data || 'Updated successfully.'))
    }
  } else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function editLedgermapAPI(data) {
  let userid = data.id
  try {
    const response = await axios.post(URL + '/master/ledgermap/update/' + userid, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for Delete Ledgermap 

function* deleteLedgermap() {
  yield takeEvery('DELETE_LEDGERMAP', saveDeleteLedgermap)
}

function* saveDeleteLedgermap(action) {
  const { response, error } = yield call(deleteLedgermapAPI, action.payload)
  if (response) yield put(deletedLedgermap({ id: action.payload.id, msg: response.data }))
  else {
    yield put(handlError(action, parseError(error)))
    sagaErrorMessage(error, action)
  }
}

async function deleteLedgermapAPI(data) {
  let ledgermapId = data.id
  try {
    const response = await axios.post(URL + '/ledgermap/delete/' + ledgermapId, data, getHeaderJWT(), { crossDomain: true });
    return ({ response });
  } catch (error) {
    return ({ error });
  }
}

//#endregion


//#region Saga for List Ledgermap 

function* fetchLedgermap() {
  yield takeEvery('FETCH_LEDGERMAP', requestLedgermap)
}


function* requestLedgermap() {
  let { data } = yield call(requestLedgermapAPI)
  yield put(fetchedLedgermap(data))
}


function requestLedgermapAPI(data) {
  data = merge({}, data, userACL.atFetch())
  return axios.post(URL + '/master/ledgermap/list', data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


//#region Saga for Search Ledgermap 

function* searchLedgermap() {

  yield takeLatest('SEARCH_LEDGERMAP', initiateSearch)

}

function* initiateSearch(action) {
  yield delay(350)
  let { data } = yield call(searchAPI, action.payload)
  yield put(storeSearchLedgermapResult(data))

}

function searchAPI(data) {
  return axios.post(URL + '/ledgermap/search/' + data, data, getHeaderJWT(), { crossDomain: true })
}

//#endregion


const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type)
  console.log(error)
  console.groupEnd()
}

export default function* ledgermapSaga() {
  yield all([
    createLedgermap(),
    fetchLedgermap(),
    editLedgermap(),
    deleteLedgermap(),
    searchLedgermap()
  ])
}  